"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Brand = void 0;
var react_1 = __importDefault(require("react"));
var hosted_assets_1 = require("@kaizen/hosted-assets");
var Brand_module_scss_1 = __importDefault(require("./Brand.module.scss"));
var Brand = function (_a) {
    var variant = _a.variant, alt = _a.alt, _b = _a.reversed, reversed = _b === void 0 ? false : _b, classNameOverride = _a.classNameOverride, restProps = __rest(_a, ["variant", "alt", "reversed", "classNameOverride"]);
    var brandTheme = reversed ? "-reversed" : "-default";
    return (react_1["default"].createElement("picture", __assign({ className: classNameOverride }, restProps),
        react_1["default"].createElement("source", { srcSet: (0, hosted_assets_1.assetUrl)("brand/".concat(variant, "-reversed.svg")), media: "(forced-colors: active) and (prefers-color-scheme: dark)" }),
        react_1["default"].createElement("source", { srcSet: (0, hosted_assets_1.assetUrl)("brand/".concat(variant, "-default.svg")), media: "(forced-colors: active) and (prefers-color-scheme: light)" }),
        react_1["default"].createElement("img", { src: (0, hosted_assets_1.assetUrl)("brand/".concat(variant).concat(brandTheme, ".svg")), alt: alt, className: Brand_module_scss_1["default"].img })));
};
exports.Brand = Brand;
exports.Brand.displayName = "Brand";
//# sourceMappingURL=Brand.js.map